// Material Kitchen 复刻主题：抽屉、缩略图、筛选和进入视口动效均使用原生 JS。
(function () {
  const body = document.body;
  const overlay = document.querySelector('[data-drawer-overlay]');
  const header = document.querySelector('[data-header]');
  const footer = document.querySelector('.mk-footer');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let footerFrame = null;

  function activeDrawers() {
    return Array.from(document.querySelectorAll('.mk-drawer.is-active'));
  }

  function closeDrawers() {
    activeDrawers().forEach((drawer) => drawer.classList.remove('is-active'));
    if (overlay) overlay.classList.remove('is-active');
    body.classList.remove('is-drawer-open');
    if (header) header.setAttribute('data-mega-open', 'false');
  }

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    body.classList.add('is-drawer-open');
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-open-drawer]');
    if (openButton) {
      event.preventDefault();
      openDrawer(openButton.getAttribute('data-open-drawer'));
      return;
    }

    if (event.target.closest('[data-close-drawer]') || event.target === overlay) {
      event.preventDefault();
      closeDrawers();
      return;
    }

    const carouselButton = event.target.closest('[data-product-carousel-prev], [data-product-carousel-next]');
    if (carouselButton) {
      const carousel = carouselButton.closest('[data-product-carousel]');
      const track = carousel ? carousel.querySelector('[data-product-carousel-track]') : null;
      if (!track) return;

      const direction = carouselButton.hasAttribute('data-product-carousel-prev') ? -1 : 1;
      track.scrollBy({
        left: direction * Math.min(track.clientWidth * 0.92, 720),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
      return;
    }

    const megaButton = event.target.closest('[data-toggle-mega]');
    if (megaButton && header) {
      event.preventDefault();
      const isOpen = header.getAttribute('data-mega-open') === 'true';
      header.setAttribute('data-mega-open', isOpen ? 'false' : 'true');
      megaButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    const thumbnail = event.target.closest('[data-product-thumb]');
    if (thumbnail) {
      const image = thumbnail.getAttribute('data-product-thumb');
      const srcset = thumbnail.getAttribute('data-product-srcset');
      const alt = thumbnail.getAttribute('data-product-alt') || '';
      const target = document.querySelector('[data-product-main-image]');
      if (target && image) {
        target.classList.add('is-switching');
        window.setTimeout(() => {
          target.setAttribute('src', image);
          if (srcset) target.setAttribute('srcset', srcset);
          target.setAttribute('alt', alt);
          target.classList.remove('is-switching');
        }, prefersReducedMotion ? 0 : 140);
        document.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      }
    }

    const filter = event.target.closest('[data-gallery-filter]');
    if (filter) {
      const value = filter.getAttribute('data-gallery-filter');
      document.querySelectorAll('[data-gallery-filter]').forEach((item) => item.classList.remove('is-active'));
      filter.classList.add('is-active');
      document.querySelectorAll('[data-gallery-item]').forEach((item) => {
        const itemValue = item.getAttribute('data-gallery-item');
        const shouldShow = value === 'all' || itemValue === value;
        if (shouldShow) {
          item.classList.remove('is-hidden');
          item.classList.add('is-entering');
          window.setTimeout(() => item.classList.remove('is-entering'), prefersReducedMotion ? 0 : 380);
        } else {
          item.classList.add('is-leaving');
          window.setTimeout(() => {
            item.classList.add('is-hidden');
            item.classList.remove('is-leaving');
          }, prefersReducedMotion ? 0 : 260);
        }
      });
    }
  });

  if (header) {
    const megaTrigger = header.querySelector('[data-toggle-mega]');
    if (megaTrigger) {
      megaTrigger.addEventListener('mouseenter', () => {
        header.setAttribute('data-mega-open', 'true');
        megaTrigger.setAttribute('aria-expanded', 'true');
      });
    }

    header.addEventListener('mouseleave', () => {
      header.setAttribute('data-mega-open', 'false');
      if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('change', (event) => {
    const optionInput = event.target.closest('[data-variant-option]');
    if (!optionInput) return;

    const form = optionInput.closest('form');
    if (!form) return;

    const variantsNode = form.querySelector('[data-product-variants]');
    const select = form.querySelector('[data-variant-select]');
    if (!variantsNode || !select) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      variants = [];
    }

    const selectedOptions = Array.from(form.querySelectorAll('[data-variant-option]:checked'))
      .sort((a, b) => Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position')))
      .map((input) => input.value);

    const matched = variants.find((variant) => {
      return selectedOptions.every((value, index) => variant.options[index] === value);
    });

    if (matched) {
      select.value = String(matched.id);
      const submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !matched.available;
        submit.style.opacity = matched.available ? '' : '0.45';
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  function updateFooterCurtain() {
    if (!footer) return;

    if (prefersReducedMotion) {
      footer.style.setProperty('--mk-footer-curtain-scale', '0');
      footer.style.setProperty('--mk-footer-opacity', '1');
      footer.style.setProperty('--mk-footer-lift', '0px');
      footer.style.setProperty('--mk-footer-scale', '1');
      footer.style.setProperty('--mk-footer-image-scale', '1');
      return;
    }

    const rect = footer.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
    const start = viewport * 0.98;
    const end = viewport * 0.22;
    const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));

    footer.style.setProperty('--mk-footer-curtain-scale', String(1 - progress));
    footer.style.setProperty('--mk-footer-opacity', String(0.66 + progress * 0.34));
    footer.style.setProperty('--mk-footer-lift', `${Math.round((1 - progress) * 76)}px`);
    footer.style.setProperty('--mk-footer-scale', String(0.975 + progress * 0.025));
    footer.style.setProperty('--mk-footer-image-scale', String(1.08 - progress * 0.08));
  }

  function requestFooterCurtainUpdate() {
    if (!footer || footerFrame) return;
    footerFrame = window.requestAnimationFrame(() => {
      footerFrame = null;
      updateFooterCurtain();
    });
  }

  window.addEventListener('scroll', () => {
    if (header) {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    }
    requestFooterCurtainUpdate();
  }, { passive: true });

  window.addEventListener('resize', requestFooterCurtainUpdate);
  requestFooterCurtainUpdate();

  const revealItems = document.querySelectorAll('[data-reveal]');
  revealItems.forEach((item, index) => {
    item.style.setProperty('--reveal-delay', `${Math.min(index * 45, 360)}ms`);
  });

  if ('IntersectionObserver' in window && revealItems.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-auto-scroll]').forEach((track) => {
    if (prefersReducedMotion) return;

    track.classList.add('is-autoscrolling');
    let direction = 1;

    window.setInterval(() => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;

      if (track.scrollLeft >= maxScroll - 4) direction = -1;
      if (track.scrollLeft <= 4) direction = 1;

      track.scrollTo({
        left: track.scrollLeft + direction * Math.min(320, track.clientWidth * 0.72),
        behavior: 'smooth',
      });
    }, 3600);
  });
})();
